import { normalizeVector, sanitizeVector } from 'leva/plugin'
import type { InternalBounce, InternalBounceSettings, BounceInput } from '../types/bounce-types'

const defaultElasticitySettings = { min: 1, max: 100, step: 1 }
const defaultGravitySettings = { min: 1, max: 200, step: 1 }
const defaultHangSettings = { min: 1, max: 150, step: 1 }
const defaultVelocitySettings = { min: 1, max: 200, step: 1 }
const defaultValue = { elasticity: 100, gravity: 100, decayX:100, decayY: 75, hang: 100, velocity: 10 }
const decayXSettings = { min: 1, max: 100, step: 1 }
const decayYSettings = { min: 1, max: 100, step: 1 }
export const normalize = (input: BounceInput = {}) => {
  const { value: _value, ..._settings } = 'value' in input ? input : { value: input }
  const mergedSettings = {
    elasticity: { ...defaultElasticitySettings, ..._settings.elasticity },
    gravity: { ...defaultGravitySettings, ..._settings.gravity },
    decayX: { ...decayXSettings, ..._settings.decayX},
    decayY: { ...decayYSettings, ..._settings.decayY},
    hang: { ...defaultHangSettings, ..._settings.hang },
    velocity: { ...defaultVelocitySettings, ..._settings.velocity },
  }
  
  const { value, settings } = normalizeVector({ ...defaultValue, ..._value }, mergedSettings)
  return { value, settings: settings as InternalBounceSettings }
}

export const sanitize = (value: InternalBounce, settings: InternalBounceSettings, prevValue?: any) =>
  // @ts-ignore
  sanitizeVector(value, settings, prevValue)